import React from 'react';
import { Spinner } from '@99designs/common/components/Spinner';
import PropTypes from 'prop-types';

function PaneSpinner({ paneTop, viewportHeight, paneHeight }) {
    const visibleHeight = viewportHeight > paneHeight ? paneHeight : viewportHeight;
    const rectHeight = paneTop < 0 ? visibleHeight : visibleHeight - paneTop;
    const rectTop = paneTop < 0 ? Math.abs(paneTop) : 0;

    const visibleRect = {
        position: 'absolute',
        top: rectTop,
        left: 0,
        height: rectHeight,
        width: '100%',
    };

    return (
        <div style={visibleRect}>
            <Spinner variations={['centered', 'large', 'soft']} />
        </div>
    );
}

PaneSpinner.propTypes = {
    paneTop: PropTypes.number.isRequired,
    viewportHeight: PropTypes.number.isRequired,
    paneHeight: PropTypes.number.isRequired,
};

export default PaneSpinner;



// WEBPACK FOOTER //
// ./src/js/components/PaneSpinner.jsx